import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {SimpleWebCouponWrapper} from '../../../features/WebCouponBanner/SimpleWebCouponBanner';
import {useIsGenericWebCouponBannerEnabled} from '../../../features/WebCouponBanner/utils/useIsGenericWebCouponBannerEnabled';
import {useRequestOffcanvasBanner} from '../useRequestDrawerNavigation';
import {OffcanvasBannerView} from './OffcanvasBannerView';

export const OffcanvasBanner: React.FC<{
  currentCategoryId?: string;
  isFirstCategoryLevelShown: boolean;
}> = props => {
  const request = useRequestOffcanvasBanner();
  const isAppWelcomeCouponBannerEnabled = useIsGenericWebCouponBannerEnabled();

  // The bulk request does not render the component when the response is undefined,
  // however, the coupon App install banner should be shown when meeting the requirements, and
  // the offcanvas banner returns nothing
  if (!request.data && isAppWelcomeCouponBannerEnabled) {
    return <SimpleWebCouponWrapper />;
  }

  return (
    <DataFetcher
      request={request}
      View={OffcanvasBannerView}
      Error={null}
      viewProps={{...props, isAppWelcomeCouponBannerEnabled}}
    />
  );
};
